<template>
  <div class="temuManifestList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            class="list-container"
            v-for="(item, index) in tableData"
            :key="index"
            @click="gotoDetail(item)"
          >
            <template v-if="menuState == 1">
              <div class="list-item">
                {{ $t.platformOrders.orderCustomerinvoicecode }}：{{
                  item.order_customerinvoicecode
                }}
              </div>
              <div class="list-item">
                {{ $t.platformOrders.wbNumber }}：{{ item.WB_Number }}
              </div>
              <div class="list-item">
                {{ $t.platformOrders.paymenttypeCode }}：{{ item.paymenttype_code }}
              </div>
              <div class="list-item">
                {{ $t.platformOrders.orderDate }}：{{ item.CreateTime }}
              </div>
            </template>
            <template v-if="menuState == 2">
              <div class="list-item">{{ $t.platformOrders.mawb }}：{{ item.MAWB }}</div>
              <div class="list-item">
                {{ $t.platformOrders.referenceNo }}：{{ item.ReferenceNo }}
              </div>
              <div class="list-item">
                {{ $t.platformOrders.packageNo }}：{{ item.PackageNo }}
              </div>
              <div class="list-item">
                {{ $t.platformOrders.createTime }}：{{ item.CreateTime }}
              </div>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <template v-if="menuState == 1">
          <div class="radio-label">{{ $t.meta.searchType }}</div>
          <van-radio-group v-model="searchType" direction="horizontal">
            <van-radio :name="1">{{
              $t.platformOrders.orderCustomerinvoicecode
            }}</van-radio>
            <van-radio :name="2">{{ $t.platformOrders.wbNumber }}</van-radio>
            <van-radio :name="3">{{
              $t.platformOrders.consigneeOrShipperName
            }}</van-radio>
            <van-radio :name="4">{{
              $t.platformOrders.consigneeOrShipperCompanyName
            }}</van-radio>
            <van-radio :name="5">{{
              $t.platformOrders.consigneeOrShipperPhone
            }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.platformOrders.paymentType }}</div>
          <van-radio-group v-model="paymenttype_code" direction="horizontal">
            <van-radio name="P">PDD</van-radio>
            <van-radio name="C">COD</van-radio>
          </van-radio-group>
        </template>

        <template v-if="menuState == 2">
          <div class="radio-label">{{ $t.meta.searchType }}</div>
          <van-radio-group v-model="searchType" direction="horizontal">
            <van-radio :name="1">{{ $t.platformOrders.referenceNo }}</van-radio>
            <van-radio :name="2">{{ $t.platformOrders.packageNo }}</van-radio>
            <van-radio :name="3">{{ $t.platformOrders.boxNo }}</van-radio>
            <van-radio :name="4">{{ $t.platformOrders.mawb }}</van-radio>
            <van-radio :name="5">{{
              $t.platformOrders.consigneeOrShipperCompanyName
            }}</van-radio>
            <van-radio :name="6">{{
              $t.platformOrders.consigneeOrShipperPhone
            }}</van-radio>
          </van-radio-group>
        </template>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "temuManifestList",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.platformOrders.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.platformOrders.tab2,
          name: 2,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.platformOrders.orderCustomerinvoicecode,
          value: 1,
        },
        {
          text: this.$t.platformOrders.wbNumber,
          value: 2,
        },
        {
          text: this.$t.platformOrders.consigneeOrShipperName,
          value: 3,
        },
        {
          text: this.$t.platformOrders.consigneeOrShipperCompanyName,
          value: 4,
        },
        {
          text: this.$t.platformOrders.consigneeOrShipperPhone,
          value: 5,
        },
      ],
      paymenttype_code: "",
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList();
    },
  },
  methods: {
    gotoDetail(item) {
      var data = item;
      data.menuState = this.menuState;
      localStorage.setItem("temuManifestDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "temuManifestDetail",
        name: "temuManifestDetail",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.paymenttype_code || (this.beginTime && this.endTime)) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.paymenttype_code = "";
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (this.menuState == 1) {
        this.searchTypeOptions = [
          {
            text: this.$t.platformOrders.orderCustomerinvoicecode,
            value: 1,
          },
          {
            text: this.$t.platformOrders.wbNumber,
            value: 2,
          },
          {
            text: this.$t.platformOrders.consigneeOrShipperName,
            value: 3,
          },
          {
            text: this.$t.platformOrders.consigneeOrShipperCompanyName,
            value: 4,
          },
          {
            text: this.$t.platformOrders.consigneeOrShipperPhone,
            value: 5,
          },
        ];
      }
      if (this.menuState == 2) {
        this.searchTypeOptions = [
          {
            text: this.$t.platformOrders.referenceNo,
            value: 1,
          },
          {
            text: this.$t.platformOrders.packageNo,
            value: 2,
          },
          {
            text: this.$t.platformOrders.boxNo,
            value: 3,
          },
          {
            text: this.$t.platformOrders.mawb,
            value: 4,
          },
          {
            text: this.$t.platformOrders.consigneeOrShipperCompanyName,
            value: 5,
          },
          {
            text: this.$t.platformOrders.consigneeOrShipperPhone,
            value: 6,
          },
        ];
      }
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 2) {
        param.ReferenceNo = this.searchType == 1 ? this.searchText : "";
        param.PackageNo = this.searchType == 2 ? this.searchText : "";
        param.BoxNo = this.searchType == 3 ? this.searchText : "";
        param.MAWB = this.searchType == 4 ? this.searchText : "";
        param.ConsigneeOrShipperName = this.searchType == 5 ? this.searchText : "";
        param.ConsigneeOrShipperPhone = this.searchType == 6 ? this.searchText : "";
        request = this.$api.platformOrders.getTemuManifestList(param);
      } else {
        param.paymenttype_code = this.paymenttype_code;
        param.order_customerinvoicecode = this.searchType == 1 ? this.searchText : "";
        param.WB_Number = this.searchType == 2 ? this.searchText : "";
        param.ConsigneeOrShipperCompanyName = this.searchType == 3 ? this.searchText : "";
        param.ConsigneeOrShipperName = this.searchType == 4 ? this.searchText : "";
        param.ConsigneeOrShipperPhone = this.searchType == 5 ? this.searchText : "";
        request = this.$api.platformOrders.getHualeiOrderList(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.temuManifestList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
}
</style>
